import { bool, func } from 'prop-types'
import { Component } from 'react'

import { ARIA_HIDDEN, OVERLAY_SELECTOR } from 'views/assets/scripts/consts'
import SearchBoxDesktop from 'views/components/organisms/SearchBox/SearchBoxDesktop'
import toggleBoolStringAttr from 'views/utils/toggleBoolStringAttribute'

import {
  SELECTOR_DESKTOP_CONTAINER,
  SELECTOR_DESKTOP_INPUT,
  SELECTOR_DESKTOP_PQSL_WRAPPER,
} from './consts'

const ARIA_FOCUSED = 'aria-focused'

class SearchBoxContainerDesktop extends Component {
  constructor(props) {
    super(props)

    this.searchBox = null
    this.overlay = null
  }

  componentDidMount() {
    const overlay = document.querySelector(OVERLAY_SELECTOR)
    const pqslWrapper = document.querySelector(SELECTOR_DESKTOP_PQSL_WRAPPER)
    const searchBoxes = [
      ...document.querySelectorAll(SELECTOR_DESKTOP_CONTAINER),
    ]

    if (Boolean(searchBoxes.length) && overlay) {
      searchBoxes.forEach(searchBox => {
        const input = searchBox.querySelector(SELECTOR_DESKTOP_INPUT)

        input.addEventListener('focus', () => {
          toggleBoolStringAttr(searchBox, ARIA_FOCUSED, true)
          toggleBoolStringAttr(overlay, ARIA_HIDDEN, false)
          toggleBoolStringAttr(pqslWrapper, ARIA_HIDDEN, false)
        })
      })

      overlay.addEventListener('click', () => {
        searchBoxes.forEach(searchBox => {
          toggleBoolStringAttr(searchBox, ARIA_FOCUSED, false)
          toggleBoolStringAttr(overlay, ARIA_HIDDEN, true)
          toggleBoolStringAttr(pqslWrapper, ARIA_HIDDEN, true)
        })

        this.props.hideResults()
      })
    }
  }

  render() {
    return (
      <SearchBoxDesktop {...this.props} handleClear={this.props.handleClear} />
    )
  }
}

SearchBoxContainerDesktop.propTypes = {
  ...SearchBoxDesktop.propTypes,
  displayResults: bool,
  handleClear: func.isRequired,
  hideResults: func.isRequired,
}

SearchBoxContainerDesktop.defaultProps = {
  ...SearchBoxDesktop.defaultProps,
  displayResults: false,
}

export default SearchBoxContainerDesktop
